// External imports
import React from 'react';
import { Button } from '@material-ui/core';
// Internal imports
import AccessControl from '~/app/Components/Auth/AccessControl.jsx';

/**
 * Print button for the form viewer list modals (Preparer Notes, Event Log,
 * Document Archive, K-1 Manager).
 *
 * Pairs the button with the print_return permission gate - the same permission
 * that guards the header bar's return print menu - so a listing cannot pick up a
 * Print action without the gate coming with it. The label is fixed; presentation
 * props (variant, size, className, style, disabled) pass through, since each
 * modal's footer styles its buttons differently.
 *
 * @component PrintListButton
 * @category Returns
 */
const PrintListButton = props => (
  <AccessControl requiredAction="write" accessLevel="print_return">
    <Button color="primary" {...props}>
      Print
    </Button>
  </AccessControl>
);

export default PrintListButton;
